




import currency from 'currency.js'

export default {
  props: {
    value: { default: 0 }
    decimals: { type: Number, default: 0 }
    currency: { type: Boolean, default: false }
  }

  data: ->
    displayed_value: 0

  computed:
    formatted_value: ->
      if @currency then currency(@displayed_value, { fromCents: true }).format({ symbol: 'R ' }) else @displayed_value.toFixed(@decimals)

  watch:
    value: (value) -> @animate_to(value)

  methods:
    animate_to: (value) ->
      cancelAnimationFrame(@animation) if @animation
      value = Number(value) || 0
      return @displayed_value = value if window.matchMedia('(prefers-reduced-motion: reduce)').matches

      from = @displayed_value
      started_at = performance.now()
      tick = (now) =>
        progress = Math.min((now - started_at) / 500, 1)
        @displayed_value = from + (value - from) * progress
        @animation = requestAnimationFrame(tick) if progress < 1
      @animation = requestAnimationFrame(tick)

  mounted: -> @animate_to(@value)

  beforeDestroy: ->
    cancelAnimationFrame(@animation) if @animation
}
